import { StyleSheet } from 'aphrodite/no-important';
import { IGenericObject } from 'models/base';
import { children, media, palette } from 'util/style-helpers';

export const style: any = (styles: IGenericObject) => {
  return StyleSheet.create({
    footerContainer: {
      background: '#000',
      color: '#FFF',
      padding: '35px 15px',
      display: 'flex',
      flexDirection: 'column',
      fontSize: 16,

      [media.tablet]: {
        textAlign: 'center',
      },

      [media.desktop]: {
        fontSize: 20,
      },
    },

    footerLinksList: {
      listStyle: 'none',
      padding: 0,
      marginBottom: 20,
      display: 'inline-block',

      [children('li')]: {
        display: 'inline-block',
        marginBottom: 5,
        paddingRight: '15px',
        borderRight: '2px solid white',
        marginRight: '15px',
      },

      [children('li:last-child')]: {
        paddingRight: 0,
        marginRight: 0,
        borderRight: 0,
      },

      [media.tablet]: {
        marginBottom: 23,
      },
    },

    link: {
      textDecoration: 'none',
      color: '#FFF',
    },

    faqLink: {
      color: palette.red,
      fontWeight: 'bold',
    },
  });
};
